import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
    relative
    cursor-pointer
    border
    border-gray-200
    p-4
    [&_img]:max-h-full
    [&_img]:max-w-full
    [&_picture]:flex
    [&_picture]:h-full
    [&_picture]:w-full
    [&_picture]:items-center
    [&_picture]:justify-center
  `,
  slots: {
    playIcon: `
      absolute
      bottom-1/2
      right-1/2
      translate-x-1/2
      translate-y-1/2
    `,
  },
  variants: {
    size: {
      sm: `
        h-40
        w-40
      `,
      md: `
        h-52
        w-52
      `,
    },
  },
});

export default styles;
